import React, {useState, useEffect} from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Card,
  Button,
} from "@mui/material";
import {
  Home,
  Work,
  Info,
  ContactMail,
  Photo,
  Description,
} from "@mui/icons-material";
import WebIcon from "@mui/icons-material/Web";
import { Link } from "react-router-dom";

const sidebardata = [
  { name: "Home", icon: <Home />, path: "/" },
  { name: "Experience", icon: <Work />, path: "/experience" },
  { name: "Projects", icon: <WebIcon />, path: "/projects" },
  { name: "About Me", icon: <Info />, path: "/about-me" },
  { name: "Blog", icon: <Description />, path: "/blogs" },
];

const Navbar = ({ selectedNav, setSelectedNav, toggleSidebar }) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to update the width
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <div className={`z-50 ${width<850 ? 'h-screen bg-[#242625]' : ''} p-4`}>
    {
      width<850 ? <button
      className="block md:hidden fixed top-4 left-4 z-50"
      onClick={toggleSidebar}
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-white">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
      </svg>
    </button>
    : null
    }
      <div className="space-y-4 bg-[#242625] rounded-lg" style={{ backgroundColor: '#242625' }}>
        <ul>
          {sidebardata.map((item) => (
            <Link
              to={item.path}
              className="flex items-center w-full"
              key={item.name}
              onClick={() => {
                setSelectedNav(item.name);
                toggleSidebar();
              }}
            >
              <li
                className={`flex items-center mb-2 py-6 px-2 cursor-pointer rounded-lg ${
                  selectedNav === item.name ? "text-[#01A5C9]" : "text-white"
                }`}
              >
                <div
                  className={`flex justify-center items-center h-6 w-6 mr-2 ${
                    selectedNav === item.name ? "text-[#01A5C9]" : "text-white"
                  }`}
                >
                  <span style={{ fontSize: "20px" }} className="flex">{item.icon}</span>
                </div>
                <div className="flex self-end">
                  <span style={{ fontSize: "20px" }}>{item.name}</span>
                </div>
              </li>
            </Link>
          ))}
        </ul>
      </div>
      <Link to="/contact" className="w-full">
        <button
          className="w-full py-2 mt-4 rounded-lg text-white"
          style={{
            background: 'linear-gradient(45deg, #56CCF2 30%, #2F80ED 90%)',
          }}
          onClick={() => {
            setSelectedNav('Contact Me');
            toggleSidebar();
          }}
        >
          Get In Touch
        </button>
      </Link>
    </div>
  );
};

export default Navbar;
